module.exports = __webpack_public_path__ + "img/compare-report.1b2af0f6.png";